export const rowBlock =
  'contents max-[899px]:col-[1/-1] max-[899px]:grid max-[899px]:grid-cols-[minmax(0,1fr)_48px] max-[899px]:overflow-hidden max-[899px]:[&>*]:border-t-0';

export const noteRowBlock = 'max-[899px]:grid-cols-[minmax(0,1fr)_44px_48px]';

export const rowCell = {
  main: 'max-[899px]:col-start-1 max-[899px]:col-end-2 max-[899px]:row-start-1',
  action:
    'max-[899px]:col-start-1 max-[899px]:col-end-2 max-[899px]:row-start-2 max-[899px]:justify-start max-[899px]:pb-2 max-[899px]:pl-3 max-[899px]:pr-0 max-[899px]:empty:hidden',
  done: 'max-[899px]:col-start-2 max-[899px]:col-end-3 max-[899px]:row-start-1 max-[899px]:row-end-3 max-[899px]:justify-center',
  doneInner: 'max-[899px]:border-0 max-[899px]:px-0 max-[899px]:py-3',
  doneAfterNote: 'max-[899px]:col-start-3 max-[899px]:col-end-4',
  note: 'items-start justify-center px-1 pt-1.5 xl:items-stretch xl:justify-start xl:p-0 max-[899px]:col-start-2 max-[899px]:col-end-3 max-[899px]:row-start-1 max-[899px]:row-end-3 max-[899px]:px-0 max-[899px]:pt-1',
};

export const doneCheckbox =
  'max-[899px]:relative max-[899px]:h-7 max-[899px]:w-7 max-[899px]:after:absolute max-[899px]:after:-inset-2';
